import React from 'react';
import "./AppSelector.css";
import MailIcon from "../../media/images/MailIcon.mjs";
import ImIcon from "../../media/images/ImIcon.mjs";
import appLib from "../../libs/appLib.mjs";
import FileIcon from "../../media/images/FileIcon.mjs";
import AnnunciIcon from "../../media/images/AvvisiIcon.mjs";

const G = window.glob;

const AppSelector = class extends React.Component {
	constructor(props) {
		super(props);
		const p = G.getStatus("Player");
		this.state = {
			admin: !! p?.admin,
			gm: !! p?.admin?.gameMaster,
			unreadMail: G.getStatus('UnreadMailCount')||0,
			unreadIm: G.getStatus('UnreadImCount')||0
		};
		this.select = this.select.bind(this);
		this.uid = G.generateUid('AppSelector');
	}
	componentDidMount() {
		G.register('UnreadMailCount', c => {
			this.setState({unreadMail: c });
		}, this.uid);
		G.register('UnreadImCount', c => {
			this.setState({unreadIm: c });
		}, this.uid);
		if ( this.state.admin && G.getStatus('Scenario')?.mailbox ) {
			appLib.hasAnagrafica().then( r => {
				this.setState({ anagrafica: r });
				G.setStatus('appHasAnnunci',true);
			});
		}
	}
	componentWillUnmount() {
		G.deregister(this.uid);
	}
	select(app) {
		appLib.setPlayerStatus(app,'simulationApp');
	}
	render() {
		const aa = this.props.simulationApp;
		return(
			<div className={"AppSelector"} id={this.uid}>
				<div className="iconsWrapper">
					<div
						className={
							"iconWrapper email " +
							(aa === 'email' ? 'active' : 'inactive') +
							( this.state.unreadMail ? ' showNotificationBullet' : '')
						}
						onClick={ ()=>{ if (aa!=='email') this.select('email')} }
					>
						<div className={"icon"}>
							<MailIcon/>
						</div>
					</div>
					<div
						className={
							"iconWrapper messages " +
							(aa === 'messages' ? 'active' : 'inactive') +
							( this.state.unreadIm ? ' showNotificationBullet' : '')
						}
						onClick={ ()=>{ if (aa!=='messages') this.select('messages')} }
					>
						<div className={"icon"}>
							<ImIcon/>
						</div>
					</div>
					{ this.state.gm && this.props.templates &&  (
						<div
							className={"iconWrapper templates " + (aa === 'templates' ? 'active' : 'inactive')}
							onClick={() => {
								if (aa !== 'templates') this.select('templates')
							}}
						>
							<div className={"icon"}>
								<FileIcon />
							</div>
						</div>
					)}
					{ this.state.anagrafica && (
						<div
							className={"iconWrapper avvisi " + (aa === 'avvisi' ? 'active' : 'inactive')}
							onClick={() => {
								if (aa !== 'avvisi') this.select('avvisi')
							}}
						>
							<div className={"icon"}>
								<AnnunciIcon />
							</div>
						</div>
					)}
				</div>
			</div>
		)
	}
};

export default AppSelector;